/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddClientRoleMappingsInput } from '../models/add-client-role-mappings-input';
import { Client } from '../models/client';
import { EntityUser } from '../models/entity-user';
import { EntityUserInput } from '../models/entity-user-input';
import { MemberUserInput } from '../models/member-user-input';
import { RequiredActionProvider } from '../models/required-action-provider';
import { Response } from '../models/response';
import { Role } from '../models/role';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class KeycloakService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiKeycloakGetEntityRolesGet
   */
  static readonly ApiKeycloakGetEntityRolesGetPath = '/api/keycloak/GetEntityRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetEntityRolesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Plain$Response(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetEntityRolesGetPath, 'get');
    if (params) {
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetEntityRolesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Plain(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<Array<string>> {

    return this.apiKeycloakGetEntityRolesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetEntityRolesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Json$Response(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetEntityRolesGetPath, 'get');
    if (params) {
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetEntityRolesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Json(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<Array<string>> {

    return this.apiKeycloakGetEntityRolesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation apiKeycloakGetMemberRegistrationSequenceGet
   */
  static readonly ApiKeycloakGetMemberRegistrationSequenceGetPath = '/api/keycloak/GetMemberRegistrationSequence';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetMemberRegistrationSequenceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetMemberRegistrationSequenceGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Plain(params?: {
    Authorization?: string;
  }): Observable<string> {

    return this.apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetMemberRegistrationSequenceGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Json$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetMemberRegistrationSequenceGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetMemberRegistrationSequenceGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Json(params?: {
    Authorization?: string;
  }): Observable<string> {

    return this.apiKeycloakGetMemberRegistrationSequenceGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiKeycloakGetUsersGet
   */
  static readonly ApiKeycloakGetUsersGetPath = '/api/keycloak/GetUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Plain$Response(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<EntityUser>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUsersGetPath, 'get');
    if (params) {
      rb.query('skip', params.skip, {});
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EntityUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Plain(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<Array<EntityUser>> {

    return this.apiKeycloakGetUsersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>) => r.body as Array<EntityUser>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Json$Response(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<EntityUser>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUsersGetPath, 'get');
    if (params) {
      rb.query('skip', params.skip, {});
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EntityUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Json(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<Array<EntityUser>> {

    return this.apiKeycloakGetUsersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>) => r.body as Array<EntityUser>)
    );
  }

  /**
   * Path part for operation apiKeycloakGetUserMembersGet
   */
  static readonly ApiKeycloakGetUserMembersGetPath = '/api/keycloak/GetUserMembers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserMembersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Plain$Response(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<EntityUser>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserMembersGetPath, 'get');
    if (params) {
      rb.query('skip', params.skip, {});
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EntityUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserMembersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Plain(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<Array<EntityUser>> {

    return this.apiKeycloakGetUserMembersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>) => r.body as Array<EntityUser>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserMembersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Json$Response(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<EntityUser>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserMembersGetPath, 'get');
    if (params) {
      rb.query('skip', params.skip, {});
      rb.query('email', params.email, {});
      rb.query('firstName', params.firstName, {});
      rb.query('lastName', params.lastName, {});
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EntityUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserMembersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Json(params?: {
    skip?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    Authorization?: string;
  }): Observable<Array<EntityUser>> {

    return this.apiKeycloakGetUserMembersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>) => r.body as Array<EntityUser>)
    );
  }

  /**
   * Path part for operation apiKeycloakGetUserGet
   */
  static readonly ApiKeycloakGetUserGetPath = '/api/keycloak/GetUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Plain$Response(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<EntityUser>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserGetPath, 'get');
    if (params) {
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntityUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Plain(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<EntityUser> {

    return this.apiKeycloakGetUserGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EntityUser>) => r.body as EntityUser)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Json$Response(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<EntityUser>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserGetPath, 'get');
    if (params) {
      rb.query('username', params.username, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntityUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Json(params?: {
    username?: string;
    Authorization?: string;
  }): Observable<EntityUser> {

    return this.apiKeycloakGetUserGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EntityUser>) => r.body as EntityUser)
    );
  }

  /**
   * Path part for operation apiKeycloakGetClientsGet
   */
  static readonly ApiKeycloakGetClientsGetPath = '/api/keycloak/GetClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Plain$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Client>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetClientsGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Client>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Plain(params?: {
    Authorization?: string;
  }): Observable<Array<Client>> {

    return this.apiKeycloakGetClientsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Client>>) => r.body as Array<Client>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetClientsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Json$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Client>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetClientsGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Client>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetClientsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Json(params?: {
    Authorization?: string;
  }): Observable<Array<Client>> {

    return this.apiKeycloakGetClientsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Client>>) => r.body as Array<Client>)
    );
  }

  /**
   * Path part for operation apiKeycloakGetUsersCountGet
   */
  static readonly ApiKeycloakGetUsersCountGetPath = '/api/keycloak/GetUsersCount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersCountGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Plain$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUsersCountGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersCountGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Plain(params?: {
    Authorization?: string;
  }): Observable<number> {

    return this.apiKeycloakGetUsersCountGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersCountGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Json$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUsersCountGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersCountGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Json(params?: {
    Authorization?: string;
  }): Observable<number> {

    return this.apiKeycloakGetUsersCountGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation apiKeycloakGetRequiredActionsGet
   */
  static readonly ApiKeycloakGetRequiredActionsGetPath = '/api/keycloak/GetRequiredActions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetRequiredActionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Plain$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<RequiredActionProvider>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetRequiredActionsGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RequiredActionProvider>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetRequiredActionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Plain(params?: {
    Authorization?: string;
  }): Observable<Array<RequiredActionProvider>> {

    return this.apiKeycloakGetRequiredActionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RequiredActionProvider>>) => r.body as Array<RequiredActionProvider>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetRequiredActionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Json$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<RequiredActionProvider>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetRequiredActionsGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RequiredActionProvider>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetRequiredActionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Json(params?: {
    Authorization?: string;
  }): Observable<Array<RequiredActionProvider>> {

    return this.apiKeycloakGetRequiredActionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RequiredActionProvider>>) => r.body as Array<RequiredActionProvider>)
    );
  }

  /**
   * Path part for operation apiKeycloakSetUserPasswordGet
   */
  static readonly ApiKeycloakSetUserPasswordGetPath = '/api/keycloak/SetUserPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakSetUserPasswordGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Plain$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakSetUserPasswordGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakSetUserPasswordGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Plain(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<boolean> {

    return this.apiKeycloakSetUserPasswordGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakSetUserPasswordGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Json$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakSetUserPasswordGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakSetUserPasswordGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Json(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<boolean> {

    return this.apiKeycloakSetUserPasswordGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiKeycloakGetAdminClientRoleMappingsForUserGet
   */
  static readonly ApiKeycloakGetAdminClientRoleMappingsForUserGetPath = '/api/keycloak/GetAdminClientRoleMappingsForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Role>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetAdminClientRoleMappingsForUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Role>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<Array<Role>> {

    return this.apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Role>>) => r.body as Array<Role>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAdminClientRoleMappingsForUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Role>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetAdminClientRoleMappingsForUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Role>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Json(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<Array<Role>> {

    return this.apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Role>>) => r.body as Array<Role>)
    );
  }

  /**
   * Path part for operation apiKeycloakGetAvailableClientRoleMappingsForUserGet
   */
  static readonly ApiKeycloakGetAvailableClientRoleMappingsForUserGetPath = '/api/keycloak/GetAvailableClientRoleMappingsForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Role>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetAvailableClientRoleMappingsForUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Role>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<Array<Role>> {

    return this.apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Role>>) => r.body as Array<Role>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Role>>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetAvailableClientRoleMappingsForUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Role>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json(params?: {
    userId?: string;
    Authorization?: string;
  }): Observable<Array<Role>> {

    return this.apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Role>>) => r.body as Array<Role>)
    );
  }

  /**
   * Path part for operation apiKeycloakAddAdminClientRoleMappingsToUserPost
   */
  static readonly ApiKeycloakAddAdminClientRoleMappingsToUserPostPath = '/api/keycloak/AddAdminClientRoleMappingsToUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response(params?: {
    Authorization?: string;
    body?: AddClientRoleMappingsInput
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakAddAdminClientRoleMappingsToUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain(params?: {
    Authorization?: string;
    body?: AddClientRoleMappingsInput
  }): Observable<boolean> {

    return this.apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakAddAdminClientRoleMappingsToUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response(params?: {
    Authorization?: string;
    body?: AddClientRoleMappingsInput
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakAddAdminClientRoleMappingsToUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Json(params?: {
    Authorization?: string;
    body?: AddClientRoleMappingsInput
  }): Observable<boolean> {

    return this.apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiKeycloakCreateUserPost
   */
  static readonly ApiKeycloakCreateUserPostPath = '/api/keycloak/CreateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Plain$Response(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakCreateUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Plain(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<Response> {

    return this.apiKeycloakCreateUserPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Json$Response(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakCreateUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Json(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<Response> {

    return this.apiKeycloakCreateUserPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * Path part for operation apiKeycloakCreateMemberUserPost
   */
  static readonly ApiKeycloakCreateMemberUserPostPath = '/api/keycloak/CreateMemberUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateMemberUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Plain$Response(params?: {
    Authorization?: string;
    body?: MemberUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakCreateMemberUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateMemberUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Plain(params?: {
    Authorization?: string;
    body?: MemberUserInput
  }): Observable<Response> {

    return this.apiKeycloakCreateMemberUserPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateMemberUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Json$Response(params?: {
    Authorization?: string;
    body?: MemberUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakCreateMemberUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateMemberUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Json(params?: {
    Authorization?: string;
    body?: MemberUserInput
  }): Observable<Response> {

    return this.apiKeycloakCreateMemberUserPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * Path part for operation apiKeycloakUpdateUserPost
   */
  static readonly ApiKeycloakUpdateUserPostPath = '/api/keycloak/UpdateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakUpdateUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Plain$Response(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakUpdateUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakUpdateUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Plain(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<Response> {

    return this.apiKeycloakUpdateUserPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakUpdateUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Json$Response(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<StrictHttpResponse<Response>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakUpdateUserPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Response>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakUpdateUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Json(params?: {
    Authorization?: string;
    body?: EntityUserInput
  }): Observable<Response> {

    return this.apiKeycloakUpdateUserPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Response>) => r.body as Response)
    );
  }

  /**
   * Path part for operation apiKeycloakMigrateRolesGet
   */
  static readonly ApiKeycloakMigrateRolesGetPath = '/api/keycloak/MigrateRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakMigrateRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakMigrateRolesGet$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakMigrateRolesGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakMigrateRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakMigrateRolesGet(params?: {
    Authorization?: string;
  }): Observable<void> {

    return this.apiKeycloakMigrateRolesGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiKeycloakGetUserProfileGet
   */
  static readonly ApiKeycloakGetUserProfileGetPath = '/api/keycloak/GetUserProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserProfileGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Plain$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserProfileGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserProfileGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Plain(params?: {
    Authorization?: string;
  }): Observable<User> {

    return this.apiKeycloakGetUserProfileGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserProfileGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Json$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakGetUserProfileGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserProfileGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Json(params?: {
    Authorization?: string;
  }): Observable<User> {

    return this.apiKeycloakGetUserProfileGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation apiKeycloakFixUserRolesGet
   */
  static readonly ApiKeycloakFixUserRolesGetPath = '/api/keycloak/FixUserRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakFixUserRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakFixUserRolesGet$Response(params?: {
    Authorization?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, KeycloakService.ApiKeycloakFixUserRolesGetPath, 'get');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakFixUserRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakFixUserRolesGet(params?: {
    Authorization?: string;
  }): Observable<void> {

    return this.apiKeycloakFixUserRolesGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
